import mixins from 'vue-typed-mixins'
import Theme from '@/global/theme/themeEnum'
import routeMixin from '@/router/routeMixin'
import Configuration from '@/configuration/configuration'
import MenuItem from './model/menuItem'
import ROUTE from '@/router/routeEnum'
import { RoleEnum } from '@/domain/role'
import { EnumPermission } from '@/domain/permission'
import globalMixin from '@/modules/globalMixin'
import mobileTypeMixin from '@/global/mobile/mobileTypeMixin'

export default mixins(routeMixin, globalMixin, mobileTypeMixin).extend({
    computed: {
        isDev: () => Configuration.isDev,
        menuItems() {
            const menus: MenuItem[] = []
            const account = this.$database.account
            const permissions = this.$database.account.permissions
            const menu = this.$translator.language.data.layout.menu
            const icon = 'mdi-format-list-bulleted-square'

            if (account.roleEnum == RoleEnum.SuperAdmin && account.permissions.indexOf(EnumPermission.User_Read) !== -1) menus.push(MenuItem.make(ROUTE.USERS, 'mdi-account-multiple', menu.users))
            if (permissions.indexOf(EnumPermission.SuiviCA_Read) !== -1) menus.push(MenuItem.make(ROUTE.SUIVICA, 'fa-percentage', menu.suiviCA))
            if (permissions.indexOf(EnumPermission.SuiviFacturation_Read) !== -1) menus.push(MenuItem.make(ROUTE.FACTURATIONS, 'fa-file-invoice-dollar', menu.facturations))
            if (permissions.indexOf(EnumPermission.SuiviConso_Read) !== -1) menus.push(MenuItem.make(ROUTE.SUIVICONSO, 'fa-chart-line', menu.suiviConso))
            if (permissions.indexOf(EnumPermission.EtatStock_Read) !== -1) menus.push(MenuItem.make(ROUTE.ETATSTOCK, 'fa-chart-pie', menu.etatStock))
            if (permissions.indexOf(EnumPermission.RotationProduits_Write) !== -1) menus.push(MenuItem.make(ROUTE.IMPORT_ROTATION_PRODUITS, 'fa-sync-alt', menu.importRotationProduits))
            if (permissions.indexOf(EnumPermission.FormulaireModele_Write) !== -1) menus.push(MenuItem.make(ROUTE.FORMULAIRE, 'fa-file-alt', menu.formulaires))
            if (permissions.indexOf(EnumPermission.FormulaireReponseAdministration_ReadWrite) !== -1) menus.push(MenuItem.make(ROUTE.FORMULAIRE_REPONSES_ADMIN, 'fa-file-alt', menu.formulairesReponseAdministration))
            if (permissions.indexOf(EnumPermission.FormulaireReponse_ReadWrite) !== -1 && (account.roleEnum == RoleEnum.Client || account.roleEnum == RoleEnum.Commercial)) menus.push(MenuItem.make(ROUTE.FORMULAIRE_REPONSES, 'fa-file-alt', menu.contact))
            if (permissions.indexOf(EnumPermission.FicheImplantation_ReadWrite) !== -1 && account.roleEnum == RoleEnum.Client) menus.push(MenuItem.make(ROUTE.FICHE_IMPLANTATION, 'fa-file-medical', menu.ficheImplantation))
            if (permissions.indexOf(EnumPermission.FicheImplantationAdministration_ReadWrite) !== -1) menus.push(MenuItem.make(ROUTE.FICHE_IMPLANTATION_ADMIN, 'fa-file-medical', menu.ficheImplantationAdmin))
            if (permissions.indexOf(EnumPermission.PMNAdministraton_ReadWrite) !== -1) menus.push(MenuItem.make(ROUTE.PMNADMINISTRATION, 'fa-file-medical-alt', menu.pmnAdministration))
            if (permissions.indexOf(EnumPermission.PMNDemande_ReadWrite) !== -1 && account.roleEnum == RoleEnum.Client) menus.push(MenuItem.make(ROUTE.PMNCLIENT, 'fa-file-medical-alt', menu.PMN))
            if (permissions.indexOf(EnumPermission.PMNDemandeListeClient_ReadWrite) !== -1) menus.push(MenuItem.make(ROUTE.PMNBIOBANK, 'fa-file-medical-alt', menu.PMN))
            if (permissions.indexOf(EnumPermission.InventaireResultat_Read) !== -1) menus.push(MenuItem.make(ROUTE.INVENTAIRES, 'fa-boxes', menu.inventaires))
            if (permissions.indexOf(EnumPermission.CommandeResultat_Read) !== -1) menus.push(MenuItem.make(ROUTE.COMMANDES, 'fa-truck-moving', menu.commandes))
            if (permissions.indexOf(EnumPermission.SuiviRecueil_Read) !== -1) menus.push(MenuItem.make(ROUTE.SUIVI_RECUEIL, 'fa-truck-loading', menu.suiviRecueil))
            if (permissions.indexOf(EnumPermission.SuiviKits) !== -1) menus.push(MenuItem.make(ROUTE.KITS, 'fa-truck-loading', menu.kits))
            
            //menus.push(MenuItem.make(ROUTE.EVENEMENTS, icon, menu.Evenements))
            menus.push(MenuItem.make(ROUTE.GED, icon, menu.GED))
            menus.push(MenuItem.make(ROUTE.ACTUALITES, icon, menu.actualites))

            return menus
        }
    },
    methods: {
        initialize() {
            this.setTheme()
            this.$vuetify.lang.current = this.$database.settings.languageCode
            this.$translator.setLanguage(this.$database.settings.languageCode)
        },
        changeTheme() {
            this.setTheme()
        },
        setTheme() {
            this.$vuetify.theme.dark = false
        },
        logout() {
            this.clearCache()
            this.$auth.logout()
            this.navigateToLogin()
        },
        clearCache() {
            this.$database.clear()
            this.$database.save()
        },
        getPastille(menu: MenuItem) {
            switch (menu.route) {
                case ROUTE.EVENEMENTS:
                    return this.pastilles.pastillesEvenements
                case ROUTE.PMNBIOBANK:
                    return this.pastilles.pastillesPMN
                case ROUTE.FORMULAIRE_REPONSES_ADMIN:
                    return this.pastilles.pastillesFormulairesReponses
                case ROUTE.FACTURATIONS:
                    return this.pastilles.pastillesDemandesFacturation
                case ROUTE.FICHE_IMPLANTATION_ADMIN:
                    return this.pastilles.pastillesDemandesDuplicataFicheImplantation
                default:
                    return null
            }

            return null
        }
    }
})
